import { useContext } from 'react';

import UtilsContext from '../contexts/Utils';

import type { Utils } from '../contexts/Utils';

const useUtils = (): Utils => useContext(UtilsContext);

export default useUtils;
